var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "webhook-form",
      attrs: {
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "180px",
        "label-position": "left"
      }
    },
    [
      _c(
        "fieldset",
        { staticClass: "mb-4" },
        [
          _c("legend", [_vm._v(_vm._s(_vm.$l10n.__("Configurer le webhook")))]),
          _vm._v(" "),
          _vm._t("endpoint")
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("format"),
      _vm._v(" "),
      _c(
        "fieldset",
        [
          _c("legend", [
            _vm._v(
              _vm._s(
                _vm.$l10n.__("Configurer les notifications envoyées au webhook")
              )
            )
          ]),
          _vm._v(" "),
          _vm._t("configDescription"),
          _vm._v(" "),
          _vm._t("configuration", [
            _c(
              "el-tabs",
              {
                staticClass: "webhooks-tabs mt-4",
                attrs: { "tab-position": "left", type: "card" }
              },
              _vm._l(_vm.parentLogs, function(log) {
                return _c(
                  "el-tab-pane",
                  {
                    key: log.id,
                    attrs: { label: log.description },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex-level" },
                                [
                                  _c("span", { staticClass: "mr-2" }, [
                                    _vm._v(_vm._s(log.description))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-tag",
                                    {
                                      staticClass: "flex-item-right",
                                      attrs: {
                                        effect: "dark",
                                        type: "warning",
                                        size: "mini"
                                      }
                                    },
                                    [
                                      _vm._t("tagEvents", null, {
                                        currentLog: log
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [_vm._v(" "), _vm._t("events", null, { log: log })],
                  2
                )
              }),
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "margin-modal" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: { click: _vm.closeModal }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "ml-2",
            attrs: { label: _vm.$t.__("common.actions.save"), type: "primary" },
            on: { click: _vm.submit }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }